<script setup lang="ts">
defineProps<{ title?: string; description?: string }>()
</script>

<template>
  <header class="text-display-sm-24px-default">
    <slot name="title">
      <h1>
        {{ title }}
      </h1>
    </slot>

    <slot name="description">
      <h2 class="text-text-subtlest">
        {{ description }}
      </h2>
    </slot>
  </header>
</template>
